import type { AuthState, User } from "./types";

const AUTH_STORAGE_KEY = "inhouse-crm-bi-session";

const emptyAuthState: AuthState = {
    user: null,
    isAuthenticated: false,
    isReady: false,
};

interface StoredSession {
    user: User;
}

export function loadStoredSession(): AuthState {
    if (typeof window === "undefined") {
        return emptyAuthState;
    }

    try {
        const rawSession = window.localStorage.getItem(AUTH_STORAGE_KEY);

        if (!rawSession) {
            return emptyAuthState;
        }

        const parsed = JSON.parse(rawSession) as Partial<StoredSession>;

        if (!parsed.user?.email || !parsed.user?.name || !Array.isArray(parsed.user?.permissions)) {
            return emptyAuthState;
        }

        return {
            user: parsed.user,
            // Не пускай authenticated UI преди /auth/me — иначе тръгват dashboard/admin заявки + 401 в конзолата.
            isAuthenticated: false,
            isReady: false,
        };
    } catch {
        return emptyAuthState;
    }
}

export function persistSession(user: User) {
    if (typeof window === "undefined") {
        return;
    }

    const payload: StoredSession = { user };
    window.localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(payload));
}

export function clearStoredSession() {
    if (typeof window === "undefined") {
        return;
    }

    window.localStorage.removeItem(AUTH_STORAGE_KEY);
}
